import { type FC, useContext } from "react";

import { FORMAT_TEXT_COMMAND } from "lexical";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import { faItalic } from "@fortawesome/free-solid-svg-icons/faItalic";

import { EditorToolbarContext } from "./editor_toolbar_context";
import { IconButton } from "./icon_button";

export const EditorToolbarButtonItalic: FC = () => {
  const [editor] = useLexicalComposerContext();
  const { isItalic } = useContext(EditorToolbarContext);

  return (
    <IconButton
      icon={faItalic}
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic");
      }}
      aria-label="Italic"
      selected={isItalic}
    />
  );
};
